<template>
  <v-container fluid class="pa-0">
    <v-layout v-for="(row, rowIdx) in rows" :key="rowIdx" wrap>
      <v-flex
        v-for="(col, colIdx) in row.Columns"
        :key="colIdx"
        xs12
        v-bind="flexProps(col.Width)"
        class="pa-2"
      >
        <component
          :is="widgetComponentMap[col.Widget]"
          :ref="`widget-${rowIdx}-${colIdx}`"
          :widget-id="`${rowIdx}-${colIdx}`"
          :config="col.Config"
          :min-width="col.MinimumWidth"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MonitoringFeaturesTableWidget from './Widgets/MonitoringFeaturesTableWidget'
import MapWidget from './Widgets/MapWidget'
import LatestIngestionEventsWidget from './Widgets/LatestIngestionEventsWidget'
import TimeSeriesGraphWidget from './Widgets/TimeSeriesGraphWidget'
import TimeSeriesGraphGroupWidget from './Widgets/TimeSeriesGraphGroupWidget'
import MonitoringFeatureGroupTimeSeriesGraphWidget from './Widgets/MonitoringFeatureGroupTimeSeriesGraphWidget'
import FortisTenantDashboardWidget from './Widgets/FortisTenantDashboardWidget'

const widgetComponentMap = {
  MonitoringFeaturesTable: MonitoringFeaturesTableWidget,
  MonitoringFeaturesMap: MapWidget,
  LatestIngestionEvents: LatestIngestionEventsWidget,
  TimeSeriesGraph: TimeSeriesGraphWidget,
  TimeSeriesGraphGroup: TimeSeriesGraphGroupWidget,
  MonitoringFeatureGroupTimeSeriesGraph: MonitoringFeatureGroupTimeSeriesGraphWidget,
  FortisTenantDashboard: FortisTenantDashboardWidget,
}

const maxColumns = 12

export default {
  name: 'WidgetDashboard',
  components: {
    MonitoringFeaturesTableWidget,
    MapWidget,
    LatestIngestionEventsWidget,
    TimeSeriesGraphWidget,
    TimeSeriesGraphGroupWidget,
    MonitoringFeatureGroupTimeSeriesGraphWidget,
    FortisTenantDashboardWidget,
  },
  data() {
    return {
      widgetComponentMap,
      loading: true,
      error: null,
    }
  },
  computed: {
    rows() {
      const config = this.$store.state.dashboard.config
      if (!config || !config.Rows) {
        return []
      }
      return config.Rows.filter(row => row.Columns && row.Columns.length > 0)
    },
  },
  methods: {
    flexProps(width) {
      return {
        [`md${width}`]: true,
        [`lg${width}`]: true,
      }
    },
    async initWidgets() {
      const config = this.$store.state.dashboard.config
      if (!config || !config.Rows) {
        return
      }
      const promises = []
      config.Rows.forEach((row, rowIdx) => {
        row.Columns.forEach((col, colIdx) => {
          const refKey = `widget-${rowIdx}-${colIdx}`
          const refs = this.$refs[refKey]
          if (refs && refs.length > 0 && refs[0].initialize) {
            promises.push(refs[0].initialize())
          }
        })
      })
      await Promise.allSettled(promises)
    },
  },
  created() {
    this.$nextTick(() => {
      this.initWidgets()
    })
  },
}
</script>
